export class Busqueda{
    constructor(
        public operacion?: string,
        public titulo?: string,
        public ciudad?: string,
        public codigo?: string
    ) {}
}